<template>
  <div>
    <v-card class="mx-auto mb-2" outlined>
      <v-card-text v-if="isEmptySubjectEmail">
        <div>{{ $t("template.lblNothingPreview") }}</div>
        <br />
      </v-card-text>
      <v-card-text v-else>
        <div>
          {{ $t("template.lblSubject") }}: <span v-html="replacedSubject" class="font-color"></span>
        </div>
      </v-card-text>
    </v-card>
    <v-card class="mx-auto mb-2" outlined>
      <v-card-text v-if="isEmptyBodyEmail">
        <div>{{ $t("template.lblNothingPreview") }}</div>
        <br />
      </v-card-text>
      <v-card-text v-else>
        <div>
          {{ $t("template.lblBody") }}: <span v-html="replacedMessage" class="font-color"></span>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "TemplatePreview",
  props: {
    item: Object,
  },
  computed: {
    ...mapGetters({
      masterSettingConfig: "tenant/masterSettingConfig",
    }),
    templatePlaceHolderItems() {
      const templateVariablesObject = this.masterSettingConfig(
        "email_template_dynamic_variables"
      );
      return templateVariablesObject["email_template_dynamic_variables"];
    },
    replacedSubject: {
      get() {
        const replacedText = this.templatePlaceHolderItems.reduce(
          (result, item) => {
            const translatedText = this.$t(`template.${item.key}`);
            const replaceText = `<span style="background-color: rgb(217, 217, 217);"><b>${translatedText}</b></span>`;

            return result.replace(new RegExp(item.value, "g"), replaceText);
          },
          this.item.subject || ""
        );
        return replacedText;
      },
    },
    replacedMessage: {
      get() {
        const replacedText = this.templatePlaceHolderItems.reduce(
          (result, item) => {
            const translatedText = this.$t(`template.${item.key}`);
            const replaceText = `<span style="background-color: rgb(217, 217, 217);"><b>${translatedText}</b></span>`;

            return result.replace(new RegExp(item.value, "g"), replaceText);
          },
          this.item.message || ""
        );
        return replacedText;
      },
    },
    isEmptySubjectEmail() {
      return this.replacedSubject === "";
    },
    isEmptyBodyEmail() {
      return this.replacedMessage === "";
    },
  },
};
</script>

<style scoped>
.font-color {
  color: #333;
}
</style>